/*  step 1 - Event Creator (creating new data)
	Event
		name,
		date,
		type,
		desc
	
*/

/*  step 2 - Event Editor (changing data)
	Event
		Controllers,
		Structure,
		is_pubnlished,
		players
	Player
		comments,
		is_present,
		slot_id
*/

/*  step 3 - Event Report (final words)
	Event
		report
	Player
		comments
*/

/*
	init: 
		edit structure, 
		add slots, 
		edit event details
	pulished:
		edit structure,
		add slots,
		edit event details,
		Edit players
	running:
		edit structure,
		add slots,
		edit event details,
		Edit players,
		Edit Attendance
		Edit comments
		Edit Report
	completed:
		** This is READONLY, Dangerous!

 */
export interface Event {
	id: number;
	name?: string;
	date?: number;
	type?: string;
	description?: string;
	squadron?: Squadron|null;
	report?: string;
	controllers?: EventController[];
	structure?: TeamObject[];
	players?: EventPlayer[];
	slots?: TeamSlot[]|null;
	status?: EventStatus|"INIT"|"PUBLISHED"|"RUNNING"|"COMPLETED";
	isPublished?: boolean;
}


export interface EventDetailsProto {
	id?: number;
	name?: string;
	date?: number;
	type?: string;
	description?: string;
	squadron?: Squadron|null;
	report?: string;
	controllers?: EventController[];
	status?: EventStatus|"INIT"|"PUBLISHED"|"RUNNING"|"COMPLETED";
	isPublished?: boolean;
}
export interface EventProto extends EventDetailsProto{
	structure?: TeamObject[];
	players?: EventPlayer[];
	slots?: TeamSlot[]|null;
}

export type SlotId = number;

export interface TeamObject {
	id: string|number;
	name: string;
	slots: SlotId[];
	children: TeamObject[];
	players?: EventPlayer[];
	position?: number;
	autoExpandSlot: string[]|null;
}
export type Team = TeamObject;

export interface TeamSlot {
	id: SlotId;
	position: number;
	role: string;
	isLeadership: boolean;
	requirements: string;
}
export interface Player {
	id: string;
	name: string;
	rank?: string;
	slotId: SlotId;
	comment?: string;
	squadron?: string;
	shipCategories?: string[];
	isPresent: boolean;
}
export interface EventPlayer {
	playerId: string;
	eventId: number;
	name: string;
	rank?: string;
	role?: string;
	slotId: SlotId;
	comment?: string;
	squadron?: string;
	shipCategories?: string[];
	isPresent: boolean;
}
export interface EventController {
	name: string;
	rank?: string;
	id: string;
}
export interface Squadron{
	id: number;
	name: string;
	type: string;
}

export enum EventStatus {
	"INIT" = "Setup", // edit structu
	"PUBLISHED" = "Published",
	"RUNNING" = "Running",
	"COMPLETED" = "Completed"
}
export enum EventStatusEmoji {
	"INIT" = "🔨", // edit structu
	"PUBLISHED" = "🎫",
	"RUNNING" = "🏃‍♂️",
	"COMPLETED" = "🏁"
}
export enum EventType {
	OPERATION, 
	TRAINING,
	MISSION,
	CIVILIAN_OPERATION,
	UNOFFICIAL_EVENT,
}
export type EventSlot = TeamSlot;

export interface EventRole {
	name: string;
	slots: number;
	emptySlots?: number;
	parent?: string;
}
export interface EventConfig {
    name: string;
    description: string;
    date: number;
    type: string;
    squadron: Number|null;
	controllers: string[];
	structure: TeamObject[];
}
export interface NodeEventRole {
	text: {
		title?: string;
		name?: string;
		"data-slots"?: string;
		"data-parent": string;
		desc?: string;
	};
	HTMLclass?: string;
	HTMLid?: string;
}
export interface EventNode {
	text: {
		title?: string;
		name?: string;
		"data-slots"?: string;
		desc?: string;
	};
	children?: Array<EventNode | NodeEventRole>;
	HTMLclass?: string;
	HTMLid?: string;
	stackChildren?: boolean;
	connectors?: boolean;
	collapsed?: boolean;
}